<template lang="pug">
.promos-header__user
  template(v-if="!isUserInProject")
    button.promos-header__user-button.promos-header__user-button--login(
      @click="login"
    ) {{ $t('common.login') }}
    button.promos-header__user-button.promos-header__user-button--register(
      @click="register"
    ) {{ $t('common.register') }}

  .promos-header__user-menu(v-else, :class="{ opened: is_menu_opened }")
    button.promos-header__user-button.promos-header__user-button--name(
      @click="toggleMenu"
    ) {{ getUserDisplayName }}
      icon(name="play")
    button.promos-header__user-button.promos-header__user-button--logout(
      @click="logout"
    ) {{ $t('common.logout') }}
</template>

<script>
import NavigationUserMixin from "@static_promo_pages/common/mixins/NavigationUserMixin";

export default {
  name: "PromosHeaderUser",
  mixins: [NavigationUserMixin],
  data() {
    return {
      is_menu_opened: false,
    };
  },
  methods: {
    toggleMenu() {
      this.is_menu_opened = !this.is_menu_opened;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/blocks/header-user";
</style>
